'use strict';

var nanNullUndef = require('../../features/Common/modules/DataTypes/utils/nanNullUndef.js');

function checkIsBrowser() {
    try {
        return nanNullUndef.checkIsDefined(window);
    }
    catch (error) {
        return false;
    }
}

exports.checkIsBrowser = checkIsBrowser;
//# sourceMappingURL=windowObj.js.map
